import Crud from "../Crud";
import MUIBlueColor from "@mui/material/colors/blue";

/**
 * Static helper functions related to modifierCodes.
 */
export default class ModifierCode extends Crud {
  /**
   * @param {object} modifierCode The modifierCode object.
   * @returns The display name of the modifierCode.
   */
  static getDisplayName(modifierCode) {
    return modifierCode.code;
  }

  /**
   * Determines if an modifierCode matches a search query.
   *
   * @param {object} modifierCode The modifierCode to test.
   * @param {string} query The search query.
   * @returns {boolean} Whether or not the modifierCode matches the query.
   */
  static match(modifierCode, query) {
    return (
      modifierCode.code.toLowerCase().includes(query) ||
      modifierCode.id === +query
    );
  }

  /**
   * @param {array} modifierCodes The list to sort.
   * @returns {array} The sorted list.
   */
  static sort(modifierCodes) {
    return modifierCodes.sort((a, b) => {
      return a.id - b.id;
    });
  }

  /**
   * @returns {string} The color of this object.
   */
  static getBaseColor() {
    return MUIBlueColor;
  }

  /**
   * @returns {string} The icon name for this object.
   */
  static getIconName() {
    return "Code";
  }
}
